module.exports = __webpack_public_path__ + "static/video-thumbnail-52c831e7a47a6527567a5332f05647f9.jpg";